class TestimonialsSlider extends HTMLElement {
  connectedCallback() {
    if (this.swiperInstance) return;

    const container = this.querySelector('.testimonials__swiper');
    if (!container || typeof Swiper === 'undefined') return;

    const prevEl = this.querySelector('.testimonials__nav-btn--prev');
    const nextEl = this.querySelector('.testimonials__nav-btn--next');
    const scrollbarEl = this.querySelector('.testimonials__scrollbar');

    this.swiperInstance = new Swiper(container, {
      slidesPerView: 1.4,
      spaceBetween: 12,
      speed: 500,
      grabCursor: true,
      watchOverflow: true,
      roundLengths: true,
      navigation: {
        prevEl,
        nextEl,
        disabledClass: 'swiper-button-disabled',
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous testimonial',
        nextSlideMessage: 'Next testimonial',
      },
    });
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

if (!customElements.get('testimonials-slider')) {
  customElements.define('testimonials-slider', TestimonialsSlider);
}

document.addEventListener('shopify:section:load', (event) => {
  const slider = event.target.querySelector('testimonials-slider');
  if (slider && typeof slider.connectedCallback === 'function') {
    slider.connectedCallback();
  }
});
